<template>
  <sq-form
      v-if="!loading&&formData"
      ref="form"
      :model="formData"
      :class="themeCtx == 'dark'?'bright-letters dark bg-dark':''"
      :title="formData.coname"
      label-width="120px"
      fillHeight="dynamic"
      v-loading="pocessing"
      element-loading-text="pocessing..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
    <s-form-actions slot="actions">
      <s-btn-delete
          v-if="formData.id"
          type="danger"
          slot="left"
          @go="deleteData()">{{ formData.unpublished_at ? 'Publish it' : 'Unpublished it' }}
      </s-btn-delete>
      <q-option-group
          slot="middle"
          v-model="formData.type"
          :options="[{
        value: 'home',
        label: 'HOME',
        icon: 'room_service',
        color: 'teal'
      },
        {
          value: 'external',
          label: 'EXTERNAL',
          icon: 'restaurant_menu'
        },]"
          color="primary"
          dark
          inline
          xtype="radio"/>
      <sf-button
          type="warning"
          @click="saveData()"
          v-if="formData.id">Update
      </sf-button>
      <sf-button
          type="primary"
          @click="saveData()"
          v-else>Create
      </sf-button>
    </s-form-actions>
    <el-tabs type="card">
      <el-tab-pane zlabel="'Details:'+(formData.coname?formData.coname:' for new company')">
        <div slot="label">
          <span class="tab-title">{{
              formData.coname ? formData.coname : 'New company'
            }}&nbsp;<i class="el-icon-office-building"></i>&nbsp; </span>
          Details
        </div>
        <s-form :fillHeight="false">
          <el-row>
            <s-form-item :sz="8">
              <label>Company Name</label>
              <el-input
                  name="coname"
                  v-model="formData.coname"/>
            </s-form-item>
            <s-form-item :sz="4">
              <label>Sh.Code</label>
              <el-input
                  name="coname"
                  v-model="formData.shortcode"/>
            </s-form-item>
            <s-form-item :sz="9">
              <label>Details</label>
              <el-input
                  name="info"
                  v-model="formData.info"/>
            </s-form-item>
            <s-form-item :sz="3">
              <label>Year</label>
              <el-input
                  name="Year"
                  v-model="formData.year"/>
            </s-form-item>
            <!--        <h4 >Ages for prices:</h4 >-->
          </el-row>
          <el-row>
            <s-form-item
                :sz="8"
                label="Kid (Any person under this age)">

              <el-input
                  name="kidsage"
                  v-model="formData.kidsage"/>
            </s-form-item>
            <s-form-item
                :sz="8"
                label="Free Kid (Any person under this age)">

              <el-input
                  name="freekidsage"
                  v-model="formData.freekidsage"/>
            </s-form-item>
            <s-form-item
                :sz="8"
                label="Infant (Any person under this age)">

              <el-input
                  name="infantage"
                  v-model="formData.infantage"/>
            </s-form-item>
          </el-row>
          <el-row>
            <s-form-item
                :sz="6"
                label="Commitions">

              <el-input
                  placeholder="Commition"
                  name="comition"
                  v-model="formData.comition">
                <template slot="append">%</template>
              </el-input>
            </s-form-item>

            <s-form-item
                :sz="6"
                label="on price">

              <el-radio-group
                  v-model="formData.commitionApplyedOn"
                  size="medium">
                <el-radio-button label="Include">Include VAT</el-radio-button>
                <el-radio-button label="Excluded">Excluded VAT</el-radio-button>
                <el-radio-button label="Own">Own Ticket</el-radio-button>
              </el-radio-group>
            </s-form-item>
            <s-form-item
                :sz="6"
                label="Ticket Policy">
              <el-select
                  v-model="formData.pr_ticket_policy"
                  clearable>
                <el-option
                    value="_id_"
                    label="Unique in the system"></el-option>
                <el-option
                    value="own"
                    label="Unique increment by company"></el-option>
              </el-select>
              <!--              <el-input-->
              <!--                  placeholder="How tickets are numbered (_id_ means by db unique id,own means unique increment by company)"-->

              <!--                  v-model="formData.pr_ticket_policy" >-->

              <!--              </el-input >-->
            </s-form-item>
            <s-form-item
                :sz="6"
                label="Vat Policy">

              <el-input
                  placeholder="How tickets are numbered (_id_ means by db unique id)"

                  v-model="formData.pr_vat">
                <template slot="append">%</template>
              </el-input>
            </s-form-item>
          </el-row>
          <el-row>
            <s-form-item
                :sz="12"
                label="Invoice sector (Σειρα)">
              <el-input
                  name="pr_sira"
                  v-model="formData.pr_sira"/>
            </s-form-item>
            <s-form-item
                :sz="12"
                label="Invoice type">
              <el-select
                  v-model="formData.pr_invoiceKind"
                  placeholder="Invoice Type"
                  clearable
                  filterable>
                <el-option
                    key="receipt"
                    label="ΑΠΥ"
                    value="receipt"></el-option>
                <el-option
                    key="invoice"
                    label="invoice"
                    value="invoice"></el-option>
                <el-option
                    key="none"
                    label="None"
                    value="none"></el-option>
              </el-select>

            </s-form-item>
            <!--            <s-form-item-->
            <!--                :sz="24"-->
            <!--                label="Pricing Policy" >-->

            <!--              <el-input-->
            <!--                  placeholder="What factors are apllyed (by_location)"-->

            <!--                  v-model="formData.pr_pricing_policy" >-->

            <!--              </el-input >-->
            <!--            </s-form-item >-->
          </el-row>
          <el-row>
            <s-form-item label="Email for forwarding notifications">
              <el-input
                  name="reportEmail"
                  v-model="formData.reportEmail"/>
            </s-form-item>
          </el-row>

        </s-form>


      </el-tab-pane>
      <el-tab-pane label="Pricing">
        <el-collapse v-model="expantedGui">
          <el-collapse-item
              title="Pricing Rules/Policies"
              name="pricing-rules">
            <el-row style="padding: 3px;box-shadow: 0px 0px 1px">
              <el-col :md="6">
                <el-select
                    v-model="formData.pr_pricing_policy"
                    placeholder="Invoice Type"
                    clearable
                >
                  <el-option
                      key="advanced_rules"
                      label="Advanced Rules"
                      value="advanced_rules"></el-option>
                  <el-option
                      key="excursion"
                      label="Excursions Pricing"
                      value="excursion"></el-option>
                  <el-option
                      key="by_location"
                      label="Pricing by location area"
                      value="by_location"></el-option>
                  <el-option
                      key=""
                      label="Transfer pricing"
                      value=""></el-option>
                </el-select>
                <!--                <el-input-->
                <!--                    placeholder="What factors are apllyed (by_location/excursion)"-->

                <!--                    v-model="formData.pr_pricing_policy" >-->

                <!--                </el-input >-->
              </el-col>
              <el-col :md="18">
                <policies-editor
                    :key="formData.pr_pricing_policy+formData?.id"
                    v-if="formData"
                    v-model="formData.pricerules"
                    :advanced-policy="formData.pr_pricing_policy=='advanced_rules'"></policies-editor>
                <!--                <el-input-->
                <!--                    v-model="formData.pricerules"-->
                <!--                    placeholder="Pricing strategy" ></el-input >-->
              </el-col>
            </el-row>
            <file-uploader
                processor="pricerules/import"
                @uploaded="++clock"
                placeholder="drop an excel file with prices, expected columns : Type,	ROUTE,	PAX min	,PAX max,	COST"
                :req-params="{tourCoId:formData.id}"></file-uploader>
          </el-collapse-item>
          <el-collapse-item v-if="formData.pr_pricing_policy!='advanced_rules'"
                            title="Filters"
                            name="filters">
            <el-row>
              <el-col :sm="6">
                <el-button
                    icon="el-icon-download"
                    @click="downloadPrices">Excel Possible Routes
                </el-button>
                <el-button
                    icon="el-icon-download"
                    @click="downloadPrices(true)">Excel Now Prices
                </el-button>
                <el-dropdown
                    v-if="pricingArchive&&pricingArchive.length"
                    @command="controlArchive('load',$event)">
                  <el-button type="primary">
                    Load archive<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu
                      slot="dropdown">
                    <el-dropdown-item

                        :command="null">Today
                    </el-dropdown-item>
                    <el-dropdown-item
                        v-for="dt in pricingArchive"
                        :command="dt">{{ formatUnxTime(dt) }}
                    </el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown>

                <sf-button
                    v-if="!priceFilter.dateunx"
                    confirm="This action will STOP the use of these pricing rules, and they are going to be kept in the archive. Shall I do it? "
                    @click="controlArchive('archiveit')">Archive It
                </sf-button>
                <el-button
                    v-if="priceFilter.dateunx"
                    @click="controlArchive('copy',priceFilter.dateunx)">Copy with cost
                </el-button>
                <el-button
                    v-if="priceFilter.dateunx"
                    @click="controlArchive('copy_no_money',priceFilter.dateunx)">Copy with no cost
                </el-button>
              </el-col>
              <el-col :sm="18">
                <el-row>
                  <el-col :sm="12">
                    <s-remote-select
                        v-model="priceFilter.in_routeseq"
                        queryProp="q"
                        classModel="locations"
                        labelProp="name"
                        placeholder="include location..."
                        valueProp="id"></s-remote-select>
                  </el-col>
                  <el-col :sm="12">
                    <s-general-select
                        v-model="priceFilter.transtype"
                        placeholder="route type..."
                        :simpleOptions="true"
                        :options="['TRANSIT','PICKUP','EXCRS']"
                        valueProp="raw"></s-general-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="12">
                    <el-input
                        placeholder="Pax >="
                        v-model="priceFilter.paxA"></el-input>
                  </el-col>
                  <el-col :sm="12">
                    <el-input
                        placeholder="Pax <="
                        v-model="priceFilter.paxZ"></el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-collapse-item>

        </el-collapse>

        <el-row v-if="formData&&formData.id">

          <s-table v-if="formData.pr_pricing_policy!='advanced_rules'"
                   heightWish="tobottom"
                   ref="rulelist"
                   :pagging="60"
                   :key="clock"
                   :allwaysEdit="false"
                   :colDefinitions="colRulesDefinitions"
                   modx-processor="pricerules/getlist"
                   :r-query="{id:$route.params.tourcoid,context:'partner',mode:'select',pricing_policy:formData.pr_pricing_policy,...priceFilter}"
                   :lazyLoader="true"
                   @data-loaded="controlArchive('meta',$event)"
                   :addEmptyLine="false"
                   @cell-input="handlePriceRule"
                   @cell-change="handlePriceRule"
                   @cell-clicked="removeRule">
            <template #top-right>
              <el-button
                  style="float: right"
                  size="large"
                  type="success"
                  @click="$refs.rulelist.appendRecord()"
                  icon="el-icon-plus"></el-button>
            </template>
          </s-table>
          <el-row type="flex" justify="center" style="padding-top: 4%">

            <q-btn color="primary" :href="'/spa3/#/cost-ruler?company='+formData.id">Go to advanced cost rule builder
            </q-btn>
          </el-row>
        </el-row>
        <el-alert
            v-else
            title="You must save first the company details (since it is a new company) before configuring price rules"
            type="warning"></el-alert>
      </el-tab-pane>
      <el-tab-pane label="Reps">
        <el-row>
          <el-switch
              active-text="Display deleted"
              inactive-text="Hide Deleted"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              v-model="deletedReps"></el-switch>
        </el-row>
        <el-row style="padding-top: 4px">
          <s-table
              heightWish="tobottom"
              ref="replist"
              :pagging="1000"
              :allwaysEdit="false"
              :colDefinitions="colRepDefinitions"
              modx-processor="rep/getlist"
              :r-query="qReps"
              :lazyLoader="false"
              :addEmptyLine="true"
              :cellClassFactory="scp=>!!scp.row.unpublished?'disabled_row':null"
              @cell-change="handleRep"
              @cell-clicked="removeRep"></s-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Commissions">
        <el-row v-if="formData&&formData.id">


          <s-table
              ref="commisions"
              heightWish="tobottom"

              :pagging="1000"
              :allwaysEdit="false"
              :colDefinitions="colPricingDefinitions"
              modx-processor="billing/getlist"
              :r-query="{coid:$route.params.tourcoid}"
              :lazyLoader="false"

              :addEmptyLine="false"
              @cell-input="handleCommisions">
            <template #top-right>
              <el-button
                  style="float: right"
                  size="large"
                  type="success"
                  @click="$refs.commisions.appendRecord({})"
                  icon="el-icon-plus"></el-button>
            </template>
          </s-table>
        </el-row>
        <el-alert
            v-else
            title="You must save first the company details (since it is a new company) before configuring price rules"
            type="warning"></el-alert>
      </el-tab-pane>
      <el-tab-pane label="VAT details">
        <BuisnessPanel
            v-if="formData&&formData.id"
            :key="formData.id"
            :contactData="formData"
            bridge-mode></BuisnessPanel>
      </el-tab-pane>
    </el-tabs>


  </sq-form>
</template>

<script>
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import STable from "../../Form/STable";
import FileUploader from "../../Form/FileUploader";
import priceRulesHandler from "../../../mixins/priceRulesHandler";

export default {
  components: {FileUploader, STable},
  mixins: [commons,
    priceRulesHandler],

  props: {},

  data() {
    return {
      deletedReps: false,
      expantedGui: ['filters'],
      priceFilter: {in_routeseq: null, dateunx: null},
      userList: [],
      selectedArchiveDate: null,
      pricingArchive: null,
      loading: true,
      pups: null,
      services: null,
      clock: 0,
      errors: {},
      pocessing: false,
      formData: {}
    };
  },
  methods: {
    downloadPrices(withPrices) {

      api.ajax_download("pricerules/getlist", {
        id: this.$route.params.tourcoid,
        context: 'partner',
        withPrices: withPrices === true ? true : null,
        download: 1,
        limit: 0
      });
    },
    async controlArchive(action, meta) {
      _log_('controlArchive', action, meta)
      if (action == 'load') {
        this.priceFilter.dateunx = meta
      }
      if (action == 'meta') {
        this.pricingArchive = meta.archive
      }
      if (action == 'archiveit') {
        const data = await api.updateProcessor("pricerules/teachprices", {
          freeze: true,
          coid: this.formData.id,
          id: this.formData.id,
          context: 'partner',
          limit: 0
        });
        ++this.clock
        // freeze: true
        // coid: 19
        // id: 19
        // context: partner
      }
      if (action == 'copy_no_money') {
        const data = await api.updateProcessor("pricerules/teachprices", {
          freeze: true,
          coid: this.formData.id,
          createCopy: true,
          noMoney: true,
          fromDate: meta
        });
        this.priceFilter.dateunx = null
        // freeze: true
        // coid: 19
        // id: 19
        // context: partner
      }
      if (action == 'copy') {
        const data = await api.updateProcessor("pricerules/teachprices", {
          freeze: true,
          coid: this.formData.id,
          createCopy: true,

          fromDate: meta
        });
        this.priceFilter.dateunx = null
        // freeze: true
        // coid: 19
        // id: 19
        // context: partner
      }
    },
    async handleCommisions(billData) {
      try {
        const isNew = !billData.row.id;
        billData.row.coid = this.formData.id;
        const data = await api.updateProcessor("billing/update", billData.row);
        _log_("get b oo ", this.$refs.replist, isNew, billData);
        if (isNew)
          this.$refs.commisions.updateRow(
              {idx: billData.row.idx},
              {id: data.id}
          );
      } catch (error) {
        _log_(error);
        alert(error.message);
      }
    },
    async deleteData() {
      this.pocessing = true;

      try {
        await api.removeObject("tourcompany", this.formData);
        this.formData.unpublished_at = this.formData.unpublished_at ? null : 1
      } catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.formData);
      this.$emit("done", null);
      this.pocessing = false;
    },
    async saveData() {
      this.pocessing = true;
      try {
        this.formData = await api.updateProcessor(
            "tourcompany/update",
            this.formData
        );
      } catch (error) {
        _log_(error);
        alert(error.message);
      }

      this.$emit("update", this.formData);
      this.$emit("change", this.formData);
      this.$emit("done", this.formData);
      this.$router.replace({params: {tourcoid: this.formData.id}});
      this.pocessing = false;
    },
    async handleRep(repData) {
      try {
        const isNew = !repData.row.id;
        repData.row.companyId = this.formData.id;
        const data = await api.updateProcessor("rep/update", repData.row);
        _log_("get b oo ", this.$refs.replist, isNew, repData);
        if (isNew)
          this.$refs.replist.updateRow(
              {idx: repData.row.idx},
              {id: data.id}
          );
      } catch (error) {
        _log_(error);
        alert(error.message);
      }
    },
    async handlePriceRule(ruleData) {
      try {
        const isNew = !ruleData.row.id;
        ruleData.row.companyId = this.formData.id;
        ruleData.row.coid = this.formData.id;
        //pricing_policy:formData.pr_pricing_policy
        if (this.formData.pr_pricing_policy) ruleData.row.scripts = {pricing_policy: this.formData.pr_pricing_policy}
        const data = await api.updateProcessor("pricerules/update", ruleData.row);

        if (isNew)
          this.$refs.rulelist.updateRow(
              {idx: ruleData.row.idx},
              {id: data.id}
          );
        else this.$refs.rulelist.updateRow(
            {idx: ruleData.row.idx},
            {editedon: data.editedon}
        );
      } catch (error) {
        _log_(error);
        alert(error.message);
      }
    },
    async loadData(id) {
      // _log_("get b oo ", this.$refs.rulelist, isNew, ruleData);
      this.loading = true;
      id = id ? id : this.$route.params.tourcoid;
      if (id) {
        if (id == "new")
          this.formData = await api.fetchObject("tourcompany", {
            tripType: this.tripKind
          });
        else
          this.formData = await api.fetchObject("tourcompany", {
            id: id
          });
      }

      this.loading = false;
    },
    async removeRep(e) {
      const vm = this;
      _log_("hell.RRs..", e);
      // _log_("trans.ss.go ii..", e);
      if (e.column.property == "delete") {
        if (this.deletedReps) {
          this.$set(e.row, 'unpublished', 0)
          await api.updateProcessor("rep/update", e.row);
          return
        }
        if (!e.row.id) return;
        this.$confirm(
            "This will permanently delete the record. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
        )
            .then(() => {
              vm.loading = true;
              vm.$refs.replist.removeRow({id: e.row.id});
              api.removeObject("rep", {id: e.row.id});

              vm.loading = false;
              // vm.removeArrayElement(this.fuelTrans, e.row, "id");
            })
            .catch(() => {
            });
      }
    },
    removeRule(e) {
      const vm = this;

      // _log_("trans.ss.go ii..", e);
      if (e.column.property == "delete") {
        if (!e.row.id) return;
        this.$confirm(
            "This will permanently delete the record. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
        )
            .then(() => {
              vm.loading = true;
              vm.$refs.rulelist.removeRow({id: e.row.id});
              api.removeObject("pricerules", {id: e.row.id});

              vm.loading = false;
              // vm.removeArrayElement(this.fuelTrans, e.row, "id");
            })
            .catch(() => {
            });
      }
    }
  },
  computed: {
    qReps() {
      return {companyId: this.$route.params.tourcoid, limit: 0, show_unpublished: this.deletedReps};
    },

    colPricingDefinitions() {
      const vm = this

      return [
        {

          prop: "serviseId",
          minWidth: "250px",
          label: "Trip",

          editable: true,

          editorcomponentFactory(row, rows) {
            return {
              is: "s-remote-select",
              extraQueryParams: {
                exclude_ids: rows.map(rw => rw.serviseId)
                    .filter(id => !!id)
              },
              queryProp: "q",
              classModel: "tripservice",
              labelProp: "title",
              captionField: 'year',
              valueProp: "id",

            }
          },
          onChange(ev, row) {
            _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.tsv_title = ev.obj.title
            }
            // if (row.meetingpoint) {
            //   const data = await api.getObject('Pup', row.meetingpoint)
            //   if (data) row.mpname = data.names
            // }
          },
          formatter: function (val, cols, row) {
            return val ? row.tsv_title + (row.tsv_year ? '@' + row.tsv_year : '') : ''
          },
        },
        {


          editable: true,

          editorcomponent: {
            is: "s-number",

          },
          prop: 'perecentcost',
          label: 'Commition(%)'
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          },
          onClick(row) {


            if (!row.id) return;
            vm.$confirm(
                "This will permanently delete the record. Continue?",
                "Warning",
                {
                  confirmButtonText: "OK",
                  cancelButtonText: "Cancel",
                  type: "warning"
                }
            )
                .then(() => {

                  vm.$refs.commisions.removeRow({idx: row.idx}, true)
                  api.removeObject("billing", {id: row.id});

                })
            // .catch(() => {
            // });

          },
        }

      ]
    },
    colRulesDefinitions() {
      let rw = "580px",
          vm = this;
      const vehicleTypes = {
        zantexp: [
          "Car-manual",
          "Car-auto",
          "Car-opentop",
          "Scouter-50",
          "Scouter-125",
          "Scouter-150",
          "QuadBike-50",
          "QuadBike-150",
          "QuadBike-300",
          "Boat-60",
          "Boat-100",
        ],
      }
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      if (this.priceRules[this.userDomain]) return this.priceRules[this.userDomain][this.formData.pr_pricing_policy || 'default'] || this.priceRules[this.userDomain].default
      if (this.userDomain == 'ionian') return [
        {

          prop: "editedon",
          editable: false,
          width: '80px',
          formatter(val) {
            if (!val) return '-';
            return vm.formatUnxTime(val)//, false, true);
          },

          label: "Last Upd"
        },
        {
          prop: "vehicletype",
          width: "",
          label: "Vehicle type",
          editable: true,
          editorcomponent: {
            is: "s-general-select",
            options: vehicleTypes.default,
            valueProp: 'value'
            // simpleOptions: true

            // multiple: true
          },
          formatter: function (val, cols, row) {
            return vm.findInArray(vehicleTypes.default, {value: val})?.label
          }
        },
        {
          prop: "transtype",
          width: "",
          label: "Route.Type",
          editable: true,
          editorcomponent: {
            is: "s-general-select",
            options: ['TRANSIT',
              'PICKUP',
              'EXCRS'],
            simpleOptions: true,

            valueProp: "raw"

            // multiple: true
          },

        },
        {

          prop: "routeseq",
          minWidth: "250px",
          label: "Location",

          editable: true,

          editorcomponent: {
            is: "RouteBuilder"

          },
          // onChange(ev, row) {
          //   // _log_("is..onChange..", ev, row);
          //   if (ev.obj && ev.obj.name) {
          //     row.loc_name = ev.obj.name
          //
          //   }
          //
          // },
          formatter(val, cols, row) {
            if (!val) return
            const parts = _.isString(val) ? val.split(',') : val
            let out = []
            parts.forEach(prt => {
              const loc = vm.findInArray(vm.pups, {loc_id: prt})
              if (loc) out.push(loc.code)
              else out.push('?' + val)

            })

            return out.join('-')
          },
        },

        {
          label: "Pax>=",
          prop: "paxA",
          width: 100,
          minWidth: 30,
          maxWidth: 180,
          editable: true,

        },
        {
          label: "<=Pax",
          prop: "paxZ",
          width: 100,
          minWidth: 30,
          maxWidth: 180,

          editable: true,

        },
        // {
        //
        //   prop: "adultPrice",
        //   editable: true,
        //   formatter(val) {
        //     return vm.formatNumber(val);
        //   },
        //   editorcomponent: {
        //     is: "s-number"
        //   },
        //   label: "Adult Price"
        // },
        // {
        //
        //   prop: "kidPrice",
        //   editable: true,
        //   formatter(val) {
        //     return vm.formatNumber(val);
        //   },
        //   editorcomponent: {
        //     is: "s-number"
        //   },
        //   label: "Kid Price"
        // },
        {

          prop: "routePrice",
          editable: true,
          formatter(val) {
            return vm.formatNumber(val, 3);
          },
          editorcomponent: {
            is: "s-number",
            digits: 3
          },
          label: "Fixed Price"
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
        // { prop: "year", width: "", label: "Date", formatterType: "unxToDate" }
      ];
      if (this.userDomain == 'zantexp') return [{
        prop: "vehicletype",
        width: "",
        label: "Vehicle type",
        editable: true,
        formatter(val) {
          if (!val) return
          return (val + '').toUpperCase()
        },
        editorcomponent: {
          is: "s-select",
          optionsRepo: "vehicleGroups",
          labelProp: "vgroup",
          valueProp: "vgroup"
          // multiple: true
        },

      },
        {
          label: "FullInsurance",
          prop: "product",
          width: 100,
          minWidth: 30,
          maxWidth: 180,

          editable: true,
          editorcomponent: {
            is: "q-checkbox",
            trueValue: 'full-insurance',
            falseValue: 'normal-insurance',
            // multiple: true
          },
          formatter(val) {
            if (val == 'full-insurance')
              return '<span class="material-icons">done</span>'
            return null
          },

        },
        {
          label: "D/2>=",
          prop: "paxA",
          width: 100,
          minWidth: 30,
          maxWidth: 180,
          editable: true,

        },
        {
          label: "<=D/2",
          prop: "paxZ",
          width: 100,
          minWidth: 30,
          maxWidth: 180,

          editable: true,

        },
        {

          prop: "routePrice",
          editable: true,
          formatter(val) {
            return vm.formatNumber(val);
          },
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }];

      return [

        {

          prop: "routeseq",
          minWidth: "250px",
          label: "Location",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",

            queryProp: "q",
            classModel: "locations",
            labelProp: "name",
            valueProp: "id",
            // extraQueryParams: {_type: 'HOTEL'},
            // xcaptionField: "typename",
            // prefixField: "loc_name",
          },
          onChange(ev, row) {
            // _log_("is..onChange..", ev, row);
            if (ev.obj && ev.obj.name) {
              row.loc_name = ev.obj.name

            }

          },
          formatter: function (val, cols, row) {
            return val && row.loc_name ? row.loc_name : ''
          },
        },
        {
          prop: "product",
          width: "",
          label: "Trip Service",
          editable: true,
          editorcomponent: {
            is: "s-general-select",
            options: vm.services,
            labelProp: "title",
            stringfy: true,

            valueProp: "id"

            // multiple: true
          },
          viewcomponent: {
            is: "s-general-select",
            options: vm.services,
            labelProp: "title",
            stringfy: true,

            valueProp: "id",
            viewMode: true
            // multiple: true
          }
        },
        {
          label: "Pax>=",
          prop: "paxA",
          width: 100,
          minWidth: 30,
          maxWidth: 180,
          editable: true,

        },
        {
          label: "<=Pax",
          prop: "paxZ",
          width: 100,
          minWidth: 30,
          maxWidth: 180,

          editable: true,

        },
        {

          prop: "adultPrice",
          editable: true,
          formatter(val) {
            return vm.formatNumber(val, 3);
          },
          editorcomponent: {
            is: "s-number",
            digits: 3
          },
          label: "Adult Price"
        },
        {

          prop: "kidPrice",
          editable: true,
          formatter(val) {
            return vm.formatNumber(val, 3);
          },
          editorcomponent: {
            is: "s-number"
          },
          label: "Kid Price"
        },
        {

          prop: "routePrice",
          editable: true,
          formatter(val) {
            return vm.formatNumber(val, 3);
          },
          editorcomponent: {
            is: "s-number"
          },
          label: "Fixed Price"
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
        // { prop: "year", width: "", label: "Date", formatterType: "unxToDate" }
      ];
    },
    colRepDefinitions() {
      var rw = "580px",
          vm = this;
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        {prop: "name", width: "", label: "Rep Name", editable: true},
        {

          prop: "uid",
          width: "",
          label: "Related Logged User",


          editable: true,
          editorcomponent: {
            is: "s-general-select",
            options: vm.userList,
            labelProp: "username",
            stringfy: true,

            valueProp: "id"

            // multiple: true
          },
          viewcomponent: {
            is: "s-general-select",
            options: vm.userList,
            labelProp: "username",
            stringfy: true,

            valueProp: "id",
            viewMode: true
            // multiple: true
          }

        },

        {
          prop: "workingPlaces",
          width: "",
          label: "Working Place",
          editable: true,
          editorcomponent: {
            is: "s-general-select",
            options: vm.pups,
            labelProp: "name",
            stringfy: true,

            valueProp: "id"

            // multiple: true
          },
          viewcomponent: {
            is: "s-general-select",
            options: vm.pups,
            labelProp: "name",
            stringfy: true,

            valueProp: "id",
            viewMode: true
            // multiple: true
          }
        },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: vm.deletedReps ? "el-icon-refresh-right" : "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
        // { prop: "year", width: "", label: "Date", formatterType: "unxToDate" }
      ];
    }
  },
  watch: {
    "$route.params.tourcoid":
        {
          handler: async function (coid, oldcoid) {
            if (!coid || coid == oldcoid) return;
            if (coid == "new") {
              this.formData = {type: 'external'}
              return;
            }
            this.pocessing = true;
            this.formData = await api.fetchObject("tourcompany", {
              id: coid
            });
            if (!this.formData.type) this.$set(this.formData, 'type', 'external')
            this.pocessing = false;
          }
          ,
          deep: true,
          immediate: true
        }
  }
}

</script>
